<div class="pb-2">
  <kendo-combobox *ngIf="dictionary !== undefined" [class.k-state-invalid]="showError" [formControl]="formControl"
    [formlyAttributes]="field" [class]="to.className" [data]="dictionary" [textField]="'displayName'"
    [valueField]="'code'" (valueChange)="to.change && to.change(field, $event)" [valuePrimitive]="true">
  </kendo-combobox>
  <kendo-combobox *ngIf="dictionary === undefined" [class.k-state-invalid]="showError" [formControl]="formControl"
    [formlyAttributes]="field" [class]="to.className" [data]="to.options | formlySelectOptions:field | async"
    [textField]="'label'" [valueField]="'value'" (valueChange)="to.change && to.change(field, $event)"
    [valuePrimitive]="true">
  </kendo-combobox>
  <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
</div>